import React from 'react';

const SettingsTabNav = ({ activeTab, onProfileClick, onProgressClick, onHistoryClick }) => {
    const tabClass = (tab, position) => {
        const isActive = activeTab === tab;
        const rounded = position === 'left' ? 'rounded-l-2xl' : position === 'right' ? 'rounded-r-2xl' : '';
        return `px-4 py-2 text-sm ${isActive ? `text-white bg-blue-500 ${rounded}` : 'text-gray-600 cursor-pointer'}`;
    };

    return (
        <div className="flex justify-center">
            <div className="border border-gray-300 bg-white rounded-2xl flex flex-row">
                <div className={tabClass('profile', 'left')}
                    onClick={activeTab === 'profile' ? undefined : onProfileClick}>
                    Profile
                </div>
                <div className={tabClass('progress', 'middle')}
                    onClick={activeTab === 'progress' ? undefined : onProgressClick}>
                    Progress
                </div>
                <div className={tabClass('history', 'right')}
                    onClick={activeTab === 'history' ? undefined : onHistoryClick}>
                    History
                </div>
            </div>
        </div>
    );
};

export default SettingsTabNav;
